<template>
  <div class="change-quantity">
    <b-modal id="modal-scoped" v-model="visibleConfirm" hide-footer no-close-on-backdrop>
      <template #modal-header="{}">
        <b>Xác nhận điều chỉnh</b>
      </template>
      <div class="box-modal" style="top: 0;">
        <div>
          <label>Lý do điều chỉnh</label>
          <el-tooltip class="item" effect="dark" visible-arrow placement="bottom-start">
            <div style="border-radius: 8px;width:300px;padding:12px" slot="content">
              Công thức tính số tồn kho sau điều chỉnh trong các trường hợp: <br />
              <div style="margin-top:10px">
                <b>1. Nhập kho, Hoàn trả</b><br />
                <div style="margin-left:15px">Số tồn mới = Số tồn cũ + Số điều chỉnh<br /></div>
              </div>
              <div style="margin-top:10px">
                <b>2. Đếm lại</b><br />
                <div style="margin-left:15px">Số tồn mới = Số điều chỉnh<br /></div>
              </div>
              <div style="margin-top:10px">
                <b>3. Hư hỏng, Bị trộm, Thất lạc</b><br/>
                <div style="margin-left:15px">Số tồn mới = Số tồn cũ - Số điều chỉnh</div>
              </div>
            </div>
            <i style="color:#3E69F6;padding: 5px;" class="el-icon-warning-outline"></i>
          </el-tooltip>
          <b-form-select v-if="type !== 2" v-model="reasonSelected" :options="type === 1 ? optionsFast : optionsLow"></b-form-select>
          <b-form-select v-else v-model="recount" :options="optionsRecount" disabled></b-form-select>
          
        </div>
        <div class="noti-confirm" v-if="type == 2">
          Xác nhận đếm lại tất cả {{seried.length}} IMEI/Se-ri? 
        </div>
        <div v-else class="noti-confirm">
          Xác nhận {{ type === 1 ? 'thêm' : 'xóa' }} {{seried.length}} IMEI/se-ri?
        </div>
        <div class="change-quantity-list-serie" style="height: 30vh;">
          <div v-for="(serie, index) in seriedDisplay" :key="index" class="list-serie-selected">
            {{ serie.label }}
          </div>
        </div>
        <div class="d-flex justify-content-end modal-footer modal-footer-change">
          <div>
            <b-button variant="primary-outline" @click="visibleConfirm = false">Quay lại</b-button>
            <el-button type="primary" :loading="btnLoading" @click="confirmChange()">
              Hoàn tất
            </el-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-scoped" v-model="visible" hide-footer no-close-on-backdrop>
      <template #modal-header="{}">
        <b>{{title}}</b>
      </template>
      <div class="box-modal" style="top: 0;">
        <b-form>
          <b-form-group
            label="Sản phẩm"
          >
            <b-form-input
              v-model="itemImei.meta.name"
              disabled
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Tên phiên bản"
          >
            <b-form-input
              v-model="itemImei.itemInstance.moreInformation.name"
              disabled
            ></b-form-input>
          </b-form-group>
          <b-form-group class="change-quantity-list-serie">
            <b-form-checkbox-group
              id="checkbox-group-2"
              v-model="seried"
            >
            <div v-for="(serie, index) in series" :key="index" style="padding: 5px 0;">
              <b-form-checkbox :value="serie.value">{{ serie.label }}</b-form-checkbox>
            </div>
            </b-form-checkbox-group>
          </b-form-group>
        </b-form>
        <div class="d-flex flex-row" v-if="type === 1 || type === 2">
          <b-form @submit.stop.prevent style="width: 100%;">
            <b-form-input v-model="txtSerie" :state="validationSeria" id="feedback-user" @keyup.native.enter="btnAddSerie" style="height: 40px;" placeholder="Thêm IMEI/Series"></b-form-input>
            <b-form-invalid-feedback :state="validationSeria">
              {{ textValidationSeria }}
            </b-form-invalid-feedback>
          </b-form>
          <el-button type="primary" style="height: 40px; background-color: #3e69f6;margin-left: 10px" :loading="btnLoading" @click="btnAddSerie">Thêm</el-button>
        </div>
        <div class="d-flex justify-content-between modal-footer modal-footer-change">
          <strong>Đã chọn: {{ amountSeried }}</strong>
          <div>
            <b-button variant="primary-outline" @click="visible = false, validationSeria = null">Thoát</b-button>
            <b-button variant="primary" style="margin: 0;" @click="nextStep()">Tiếp tục</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-dropdown toggle-class="text-decoration-none" size="lg" variant="link" class="text-align-center" no-caret right>
      <template #button-content>
        <i style="color: rgb(116, 120, 141);" class="el-icon-more" />
      </template>
      <b-dropdown-item @click="handleModal('up')">Thêm nhanh IMEI</b-dropdown-item>
      <b-dropdown-item @click="handleModal('down')">Giảm nhanh IMEI</b-dropdown-item>
      <b-dropdown-item @click="handleModal('middle')">Đếm lại IMEI</b-dropdown-item>
      <b-dropdown-item @click="clickBarcodeChoose(itemImei)">In mã vạch</b-dropdown-item>
    </b-dropdown>
    <!-- loading -->
    <div class="box-loading" v-if="loading">
      <div class="loading">
        <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
      </div>
    </div>
  </div>
</template>
<script>
import checkSerialItem from '../../../mixins/storage/checkSerialItem'
import { getLocationID } from '../../../utils/auth'
import { reasons } from '../../../utils/mapping'
import { validSeria } from '../../../utils/validate'
import { InventoryService } from '../../../services/nextshop/inventory.service'
import { checkSerialExist } from '@/mixins/storage/checkSerial.js'
export default {
  props: {
    itemImei: {
      type: Object,
      default: () => {

      }
    }
  },
  data() {
    return {
      validationSeria: null,
      textValidationSeria: '',
      visible: false,
      visibleConfirm: false, 
      btnLoading: false,
      txtSerie: '',
      title: '',
      type: 0, //0: giảm tồn nhanh 1: thêm tồn nhanh 2: đếm lại
      seried: [],
      series: [],
      seriesInit: [],
      reasonSelected: 0,
      recount: 'RECOUNT',
      optionsFast: reasons.filter(re => re.index < 2),
      optionsRecount: reasons.filter(re => re.index == 2),
      optionsLow: reasons.filter(re => re.index >= 3),
      loading: false,
    }
  },
  mixins: [checkSerialItem],
  watch: {
    txtSerie() {
      if (!this.txtSerie) {
        this.txtSerie = ''
        this.validationSeria = null
      }
    },
  },
  computed: {
    amountSeried() {
      return this.seried.length
    },
    seriedDisplay() {
      return this.seried.map(s => {
        return {
          value: s,
          label: s
        }
      })
    }
  },
  methods: {

    clickBarcodeChoose(itemBarCode) {
      this.$emit('clickBarcodeChoose', itemBarCode)
    },

    async handleModal(type) {
      try {
        this.loading = true
        this.seried = []
        // lấy tất cả imei theo sku 
        const inventoryId = localStorage.getItem("inventoryID")
        const getSerialBySKU = await this.checkSerialItem(this.itemImei.sku, inventoryId)
        const series = getSerialBySKU.data.map((serial) => {
          return {
            value: serial.serieNo,
            label: serial.serieNo
          }
        })
        this.loading = false
        this.seriesInit = series
        if (type === 'up') {
          this.title = 'Thêm nhanh tồn'
          this.type = 1
          this.reasonSelected = this.optionsFast[0].value
          this.seried = []
          this.series = []
        } else if (type == 'down') {
          this.title = 'Giảm nhanh tồn'
          this.type = 0
          this.reasonSelected = this.optionsLow[0].value
          this.series = series
        } else {
          this.title = 'Đếm lại tồn kho'
          this.type = 2
          this.seried = []
          this.series = []
        }
        this.visible = true
      } catch (error) {
        console.log(error);
        this.loading = false
      }
     
    },
    btnAddSerie() {
      const checkSeria = this.series.find(ser => ser.label.trim().toLowerCase() === this.txtSerie.trim().toLowerCase())
      if (!validSeria(this.txtSerie)) {
        this.validationSeria = false
        this.textValidationSeria = 'Độ dài của serial/imei là từ 3 - 25 ký tự, viết liền, không chứa ký tự đặc biệt trừ “-” và “_”'
        return
      } else if (checkSeria) {
        this.validationSeria = false
        this.textValidationSeria = 'Đã tồn tại serial/imei trong danh sách. Vui lòng nhập mã serial/imei khác!'
        return
      }
      this.btnLoading = true
      if(this.type == 1) {
        checkSerialExist(this.txtSerie).then(res => {
          if (res.data.length > 0) {
            this.validationSeria = false
            this.textValidationSeria = 'Đã tồn tại serial/imei trên hệ thống. Vui lòng nhập mã serial/imei khác!'
            this.btnLoading = false
            return
          }
          this.btnLoading = false
          this.series.unshift({ value: this.txtSerie.trim(), label: this.txtSerie.trim() })
          this.seried.unshift(this.txtSerie.trim())
          this.txtSerie = ''
          this.validationSeria = null
          this.textValidationSeria = ''
        })
      } else {
        checkSerialExist(this.txtSerie, this.itemImei.sku).then(res => {
          if (res.data.length > 0) {
            this.validationSeria = false
            this.textValidationSeria = 'Đã tồn tại serial/imei ở sản phẩm khác trên hệ thống. Vui lòng nhập mã serial/imei khác!'
            this.btnLoading = false
            return
          }
          this.btnLoading = false
          this.series.unshift({ value: this.txtSerie.trim(), label: this.txtSerie.trim() })
          this.seried.unshift(this.txtSerie.trim())
          this.txtSerie = ''
          this.validationSeria = null
          this.textValidationSeria = ''
        })
      }
    },
    nextStep() {
      if (this.seried.length === 0 && (this.type === 1 || this.type === 2)) {
        this.$message.warning(`Hãy chọn IMEI/Seria mà bạn muốn ${this.title.toLowerCase()}`)
        return
      }
      this.visibleConfirm = true
    },
    confirmChange() {
      let req = {};
      const { name, unit, moreInformation } = this.itemImei.itemInstance
      const { price, id, checkInAt, sku, inventoryId } = this.itemImei
      const _unit = this.itemImei.unit
      let quantityCurrent = 0
      if (this.reasonSelected === 'ADD' || this.reasonSelected === 'RETURN') {
        quantityCurrent = this.seriesInit.length + this.seriedDisplay.length
      } else {
        quantityCurrent = this.seriesInit.length - this.seriedDisplay.length
      }
      req = {
        inventoryId: inventoryId,
        lineItemId: id,
        lineItemReqs: [
          {
            action: '',
            addedAmount: [],
            itemInstance: {
              ItemId: id,
              name: name,
              moreInformation: {
                sku: sku,
                name: moreInformation.name,
                upc: moreInformation.upc
              }
            },
            lineItemId: id,
            quantityAfterChange: quantityCurrent,
            quantityChange: Math.abs(quantityCurrent - this.seriesInit.length),
            quantityCurrent: this.seriesInit.length,
            reason: this.reasonSelected,
            typeChange: this.reasonSelected,
            series: this.seriedDisplay.map(s => s.value),
            unitPrice: price,
            unit: (unit.name) ? unit.name : _unit,
            amount: 0,
            totalAmount: 0,
            expiredAt: checkInAt,
            checkInAt: checkInAt,
            tax: [],
            discount: [],
            ...(this.type == 2 && {
              quantityAfterChange : this.seried.length,
              oldSeries : this.seriesInit.map(s => s.value),
              typeChange : "RECOUNT",
              reason: "RECOUNT"
              }
            ),
          }
        ],
        locationId: getLocationID(),
        unit: (unit.name) ? unit.name : _unit
      }
      this.btnLoading = true
      InventoryService.inventoryItemChange(req).then(res => {
        this.btnLoading = false
        if (res.success) {
          this.$notify({
            type: 'success',
            title: 'Thông báo',
            message: 'Cập nhật imei/serial thành công'
          })
          this.visible = false
          this.visibleConfirm = false
          this.$emit('callback', quantityCurrent)
        }
      })
    }
  }
}
</script>